exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flexContainer {\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    float: right;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared/numeric-input-editable/numeric-input-editable.component.css
// module id = ../../../../../src/app/shared/numeric-input-editable/numeric-input-editable.component.css
// module chunks = 16